/**
 * LocalStorage key constants
 * Centralized storage key management for consistency and maintainability
 */
export const STORAGE_KEYS = {
  USER_NAME: 'user_name',
  STAY_LOGIN: 'stayLogin',
  IS_LOGIN: 'isLogin',
  AGE_SELECTED_INDEX: 'ageSelectedIndex',
  SKIP_HEALTH_CHECK: 'skipHealthCheck',
  N_QUESTIONS: 'nQuestions',
};
